module.exports = __webpack_public_path__ + "img/27n.cdfcc7bb.png";